export enum ColorMapMode {
  EQUAL = 'equal',
  CONTINUOUS = 'continuous',
  QUANTILE = 'quantile'
}

export enum ColorMapInterpolation {
  DISCRETE = 'discrete',
  LINEAR = 'linear',
  EXACT = 'exact'
}
